import { useState } from 'react';
import BottomModal from '../../../components/modal/BottomModal';
import {
  CancleButton,
  ConfirmButton,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from '../../../components/modal/Modal.style';
import {
  ModalInfo,
  Section,
  SelectContent,
  Option,
} from './SelectModal.styles';
import { profitRateOptions } from '../data';
import styled from 'styled-components';

interface Props {
  selected: string;
  onApply: (selected: string) => void;
  onClose: () => void;
}

function DiscountModal({ selected, onApply, onClose }: Props) {
  const [selectedItem, setSelectedItem] = useState<string>(selected);

  const isChecked = (value: string) => selectedItem === value;

  const toggleItem = (item: string) => {
    setSelectedItem(item);
  };

  const handleApply = () => {
    onApply(selectedItem);
    onClose();
  };
  return (
    <BottomModal onClose={onClose}>
      <ModalHeader>
        <ModalTitle>할인비율</ModalTitle>
        <ModalCloseButton
          onClick={onClose}
          src="/assets/images/close/close-dark-gray.svg"
          alt="close"
        />
      </ModalHeader>
      <Section $gap={16}>
        <ModalInfo>목표로 하는 감정가 대비 할인 비율을 선택해주세요</ModalInfo>
        <SelectContent>
          {profitRateOptions.map((option) => (
            <Option key={option.label} $active={isChecked(option.value)}>
              <label>
                <input
                  type="checkbox"
                  checked={isChecked(option.value)}
                  onChange={() => toggleItem(option.value)}
                />
                <LabelContainer>
                  {option.label}
                  <Desc>{option.description}</Desc>
                </LabelContainer>
                {isChecked(option.value) && (
                  <img
                    src="/assets/images/check/blue_check_24.svg"
                    onClick={() => toggleItem(option.value)}
                    alt=""
                  />
                )}
              </label>
            </Option>
          ))}
        </SelectContent>
      </Section>
      <ModalFooter>
        <CancleButton onClick={onClose}>취소</CancleButton>
        <ConfirmButton $disabled={selectedItem === ''} onClick={handleApply}>
          적용
        </ConfirmButton>
      </ModalFooter>
    </BottomModal>
  );
}

export default DiscountModal;

const LabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
`;

const Desc = styled.div`
  color: rgba(55, 56, 60, 0.61);
  font-size: 14px;
  font-weight: 500;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
`;
